import React, { useState } from 'react';
import doctorWithoutPhoto from '../../assets/images/doctor-without-photo.png';

const doctorItem = require('b_').with('doctor-item');

export const DoctorPhoto = ({ photoLink }) => {
    const [ failedPhotoLink, setFailedPhotoLink ] = useState(null);
    const [ photoDimensions, setPhotoDimensions ] = useState(null);
    const photoSrc = photoLink && photoLink !== failedPhotoLink ? photoLink : doctorWithoutPhoto;
    const isDoctorPhoto = photoSrc !== doctorWithoutPhoto;

    const onLoad = (event) => {
        if (isDoctorPhoto) {
            const { naturalWidth, naturalHeight } = event.currentTarget;
            setPhotoDimensions({ src: photoSrc, wide: naturalWidth > naturalHeight, slim: naturalHeight > naturalWidth });
        }
    };

    const onError = () => {
        if (isDoctorPhoto) {
            setFailedPhotoLink(photoSrc);
        }
    };

    return (
        <img
            className={doctorItem('photo', {
                wide: isDoctorPhoto && photoDimensions?.src === photoSrc && photoDimensions.wide,
                slim: isDoctorPhoto && photoDimensions?.src === photoSrc && photoDimensions.slim,
            })}
            src={photoSrc}
            alt="doctor"
            onLoad={onLoad}
            onError={onError}
        />
    );
};
